import { useState, useEffect } from "react";
import UpperLayerTabLayout from "../../../Components/DetailsPageUpperLayer/UpperLayerTabLayout";

const InboundDeliveryHeader = ({ hProps }) => {
  const [deliveryDetails, setDeliveryDetails] = useState({});
  const [freightDetails, setFreightDetails] = useState({});

  const fieldLabels = {
    lob: "LOB",
    eta: "ETA",
    ata: "ATA",
    poScheduledConfirmedDeliveryDate: "PO Scheduled Confirmed Delivery Date",
    pta: "PTA",
  };

  // Function to seed data with defaults (null in this case)
  const seedWithDefaults = (src, keys) =>
    keys.reduce((acc, k) => {
      acc[k] = src?.[k] ?? null; // Default to null, can be adjusted to other defaults (like "TBD")
      return acc;
    }, {});

  useEffect(() => {
    // Keys related to Delivery
    const deliveryKeys = [
      "deliveryNo",
      "deliveryType",
      "lob",
      "supplier",
      "supplierName",
      "customer",
      "customerName",
      // "packingSlipNo",
      "creationDate",
      "plannedShipDate",
      "actualShipDate",
      "eta",
      "ata",
      "pta",
      "poScheduledConfirmedDeliveryDate",
    ];

    // Keys related to Freight
    const freightKeys = [
      "shipmentNo",
      "shipmentLineNo",
      "shipFrom",
      "shipFromOwner",
      "shipFromSite",
      "shipTo",
      "shipToOwner",
      "shipToSite",
      "shipMode",
      "carrier",
    ];

    // Seed the data with default values (null) for both delivery and freight
    let deliveryObj = seedWithDefaults(hProps || {}, deliveryKeys);
    let freightObj = seedWithDefaults(hProps || {}, freightKeys);

    // Set default data in the state
    setDeliveryDetails(deliveryObj);
    setFreightDetails(freightObj);
  }, [hProps]); // Trigger this effect when hProps changes

  return (
    <UpperLayerTabLayout
      firstHeading="Delivery"
      secondHeading="Freight"
      firstBoxData={deliveryDetails} // Display delivery details
      secondBoxData={freightDetails} // Display freight details
      title="Inbound Deliveries Detail"
      showThirdTab={false} // No third tab for Track & Trace
      showTrackAndTrace={false} // Disable Track & Trace
      fieldLabels={fieldLabels}
    />
  );
};

export default InboundDeliveryHeader;
